import styled from '@emotion/styled';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { COLORS3 as COLORS, FONT, MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';

export const ProductPriceWrapper = styled.div<{ isOneLine?: boolean }>`
  font-size: ${props => (props.isOneLine ? FONT.FONT_SIZE_EXTRA_SMALL : 'inherit')};
  line-height: inherit;
  margin: 0 0 4px 0;
  overflow: hidden;
  white-space: nowrap;

  ${MEDIA_QUERY.MOBILE_XS} {
    font-size: ${FONT.FONT_SIZE_SMALLER};
  }
`;

export const OnPromotion = styled.span`
  color: ${COLORS.ROSE_100};
`;

export const StyledLink = styled(LinkV2)`
  &:hover {
    text-decoration: underline !important;
  }
`;
